import { FC } from 'react';
import { Segmented } from 'antd';

import { BillingInterval } from '@/constants';

export interface BillingIntervalToggleProps {
    onChange: (value: BillingInterval) => void;
    value: BillingInterval;
}

const BillingIntervalToggle: FC<BillingIntervalToggleProps> = ({ onChange, value }) => (
    <Segmented
        onChange={(nextValue) => onChange(nextValue as BillingInterval)}
        options={[
            { label: 'Monthly', value: 'monthly' },
            { label: 'Annual', value: 'annual' },
        ]}
        value={value}
    />
);

export default BillingIntervalToggle;
